<template>
  <Layout>
    <div class="dashboard">
      <el-row :gutter="20">
        <!-- 广告计划统计卡片 -->
        <el-col :span="8">
          <el-card shadow="hover" class="dashboard-card">
            <div slot="header" class="card-header">
              <span>广告计划</span>
            </div>
            <div class="card-content">
              <div class="card-number">{{ campaigns.length }}</div>
              <div class="card-text">总计划数</div>
            </div>
          </el-card>
        </el-col>
        
        <!-- 活跃广告计划卡片 -->
        <el-col :span="8">
          <el-card shadow="hover" class="dashboard-card">
            <div slot="header" class="card-header">
              <span>活跃计划</span>
            </div>
            <div class="card-content">
              <div class="card-number">{{ activeCampaigns.length }}</div>
              <div class="card-text">活跃状态</div>
            </div>
          </el-card>
        </el-col>
        
        <!-- 物料统计卡片 -->
        <el-col :span="8">
          <el-card shadow="hover" class="dashboard-card">
            <div slot="header" class="card-header">
              <span>物料</span>
            </div>
            <div class="card-content">
              <div class="card-number">{{ materials.length }}</div>
              <div class="card-text">总物料数</div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 最近广告计划列表 -->
      <el-card shadow="hover" class="campaign-list-card">
        <div slot="header" class="card-header">
          <span>最近广告计划</span>
          <el-button type="text" @click="$router.push('/campaigns')">查看全部</el-button>
        </div>
        <el-table :data="recentCampaigns" stripe style="width: 100%">
          <el-table-column prop="name" label="计划名称" min-width="260" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)">{{ formatStatus(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="$router.push(`/campaigns/edit/${scope.row.id}`)" type="text" size="small">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  components: {
    Layout
  },
  computed: {
    ...mapState(['campaigns', 'materials']),
    ...mapGetters(['getActiveCampaigns']),
    activeCampaigns() {
      return this.getActiveCampaigns
    },
    recentCampaigns() {
      return [...this.campaigns].sort((a, b) => {
        return new Date(b.create_time) - new Date(a.create_time)
      }).slice(0, 5)
    }
  },
  methods: {
    getStatusType(status) {
      switch (status) {
        case 'reviewing':
          return 'warning'
        case 'active':
          return 'success'
        case 'paused':
          return 'warning'
        case 'stopped':
          return 'danger'
        case 'completed':
          return 'success'
        default:
          return 'info'
      }
    },
    formatStatus(status) {
      switch (status) {
        case 'reviewing':
          return '审核中'
        case 'active':
          return '运行中'
        case 'paused':
          return '已暂停'
        case 'stopped':
          return '已停止'
        case 'completed':
          return '已完成'
        default:
          return '未知'
      }
    }
  },
  created() {
    this.$store.dispatch('fetchCampaigns')
    this.$store.dispatch('fetchMaterials')
  }
}
</script>

<style scoped>
.dashboard {
  padding: 20px 0;
}

.dashboard-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 120px;
}

.card-number {
  font-size: 36px;
  font-weight: bold;
  color: #409EFF;
  margin-bottom: 10px;
}

.card-text {
  font-size: 14px;
  color: #606266;
}

.campaign-list-card {
  margin-top: 20px;
}
</style> 
